import React from 'react'
import styled from '@emotion/styled';

const MenuWrapper = styled.div`
    position: absolute;
    width: 100%;
    width: ${props => props.width};
    top: 46px;
    z-index: 1000;
    overflow-y: auto;
    max-height: 300px;
    visibility: ${props => props.isActive ? 'display' : 'hidden'};
    background: ${props => props.theme.colors.white};
    box-shadow: ${props => props.theme.shadow.menu};
    border-bottom-left-radius: ${props => props.theme.borderRadius.round};
    border-bottom-right-radius: ${props => props.theme.borderRadius.round};
    border-top-left-radius: ${props => props.theme.borderRadius.round};
    border-top-right-radius: ${props => props.theme.borderRadius.round};
    ul,
    li {
        margin: 0px;
    }
`;

const MenuList = styled.ul`
    list-style-type: none;
    li {
        color: ${props => props.theme.colors[props.color]};
        line-height: 24px;
        cursor: pointer;
        &:hover {
            background-color: ${props => props.theme.colors.lightBlue};
        }
        padding: 10px;
    }
`
const DropDownMenu = props => {
    return (
        <MenuWrapper isActive = {props.isActive}>
            {props.menuItems && <MenuList color = {props.color}>
                {props.menuItems.map( (menuItem, i) => (
                    <li
                        key={ menuItem }
                        onClick={() => props.handleClick(menuItem)}
                    >
                        {menuItem}
                    </li>
                ))}
            </MenuList>}
        </MenuWrapper>
    )
}

export default DropDownMenu;